// AuthContext.js
import React, { createContext, useState } from "react";
import TokenService from "../../service/TokenService";

// Create the context
export const AuthContext = createContext(TokenService.getUserDetails());

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(TokenService.getUserDetails());

  const clearAuth = () => {
    setAuth({});
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth, clearAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
